// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.properties.waitlist.RentalManagerUserPropertyWaitlistV2WebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserPropertyWaitlistV2WebApiHandler_disable,
  RentalManagerUserPropertyWaitlistV2WebApiHandler_enable,
} from '@zg-rentals/ts-rental-manager-api-client';

import type {
  UserPropertyWaitlistDisableV2RequestDto,
  UserPropertyWaitlistEnableV2RequestDto,
} from '@zg-rentals/ts-rental-manager-api-client';

export interface RentalManagerUserPropertyWaitlistV2WebApiHandler_disable_Args {
  postData: UserPropertyWaitlistDisableV2RequestDto;
}

export type RentalManagerUserPropertyWaitlistV2WebApiHandler_disable_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyWaitlistV2WebApiHandler_disable_Args
>;

/**
 * Disable waitlist feature for a property
 */
export const useRentalManagerUserPropertyWaitlistV2WebApiHandler_disable = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyWaitlistV2WebApiHandler_disable_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyWaitlistV2WebApiHandler_disable_Args) =>
      RentalManagerUserPropertyWaitlistV2WebApiHandler_disable(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyWaitlistV2WebApiHandler_enable_Args {
  postData: UserPropertyWaitlistEnableV2RequestDto;
}

export type RentalManagerUserPropertyWaitlistV2WebApiHandler_enable_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyWaitlistV2WebApiHandler_enable_Args
>;

/**
 * Enable waitlist feature for a property
 */
export const useRentalManagerUserPropertyWaitlistV2WebApiHandler_enable = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyWaitlistV2WebApiHandler_enable_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyWaitlistV2WebApiHandler_enable_Args) =>
      RentalManagerUserPropertyWaitlistV2WebApiHandler_enable(args.postData, httpClient),
  });
};
